<importer-sub-header title="Details of Log"></importer-sub-header>
@if (data) {
  <div class="container">
    <div class="side-bar">
      <div (click)="goBack()">
        <span
          class="material-icons"
          style="color: white">
          fast_rewind
        </span>
      </div>
      <div style="display: flex; flex-direction: column">
        <div class="single-menu menu-rotate-small">
          <h4
            class="headline-texts"
            style="writing-mode: vertical-rl">
            {{ (data.fileName | fileName) || 'n/a' }}
          </h4>
        </div>
      </div>
    </div>
    <div>
      @if (data.state === 'Staged' && !data.fileType.threshold && data.fileType.threshold !== 0) {
        <div>
          <ng-template #buttonsRightTemplate>
            @for (enum of actionEnum | keyvalue; track enum) {
              <coin-v2-button
                [type]="enum.value === 'Reject' ? 'secondary' : 'primary'"
                [icon]="'save'"
                [iconPos]="'right'"
                [text]="enum.value"
                (click)="openPopup(enum.value)"></coin-v2-button>
            }
          </ng-template>
          <importer-button-footer [buttonsRightTemplate]="buttonsRightTemplate"></importer-button-footer>
        </div>
      }
      @if (data.state === 'Published') {
        <div>
          <ng-template #buttonRepublish>
            <coin-v2-button
              [type]="'secondary'"
              [icon]="'upload'"
              [iconPos]="'right'"
              [text]="'Republish changes'"
              (click)="republishChanges()"></coin-v2-button>
          </ng-template>
          <importer-button-footer [buttonsRightTemplate]="buttonRepublish"></importer-button-footer>
        </div>
      }
      @if (data.state === 'Failed') {
        <div>
          <ng-template #buttonsCenterTemplate>
            <h3 class="error">{{ formatErrorMessage(data.message) }}</h3>
          </ng-template>
          <importer-button-footer [buttonsCenterTemplate]="buttonsCenterTemplate"></importer-button-footer>
        </div>
      }
      <div
        class="records-details-container"
        [class.smaller]="data.state === 'Staged' || data.state === 'Failed' || data.state === 'Published'">
        @if (data.coinProcessingState) {
          <div class="target-view">
            <div class="inner one">
              <div class="box mat-elevation-z4">
                <p class="bold head">Coin Transaction State</p>
                <div class="content">
                  <importer-transaction-state-progress-bar [data]="data"></importer-transaction-state-progress-bar>
                </div>
              </div>
            </div>
          </div>
        }
        @if (data.state !== 'Staged') {
          <div class="target-view">
            <div class="inner one">
              <div class="box mat-elevation-z4">
                <p class="bold head">Decision on Import</p>
                <div class="content">
                  <importer-import-decision [data]="data"></importer-import-decision>
                </div>
              </div>
            </div>
          </div>
        }
        <h4>Analysis of Datasets</h4>
        <div class="target-view">
          <div class="inner two">
            <div style="display: flex; justify-content: center; align-items: center">
              <importer-charts
                level="datasets"
                [importStats]="data.stats"></importer-charts>
            </div>
            <div class="box mat-elevation-z4">
              <p class="bold head">Summary</p>
              <div class="content">
                <importer-import-details [data]="data"></importer-import-details>
              </div>
            </div>
          </div>
        </div>
        <h4>Analysis of Changes with Validation Rules</h4>
        <div class="target-view">
          <div class="inner two">
            <div style="display: flex; justify-content: center; align-items: center">
              <importer-charts
                level="changes"
                [importStats]="data.stats"></importer-charts>
            </div>
            <div class="box mat-elevation-z4">
              <p class="bold head">Summary</p>
              <div class="content">
                <importer-validation-list [importStats]="data.stats"></importer-validation-list>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
